export const DISABLED_UNVERIFIED_BANNER_PATHS = [
  '/email-verification',
];

export const CREDIT_REFRESH_MODAL_KEY = 'growth/CreditRefreshModal';

export const LOCAL_STORAGE_KEY_ACTIVE_TEAM = 'activeTeam';
